import { render, staticRenderFns } from "./jdfp.vue?vue&type=template&id=4366e488&scoped=true"
import script from "./jdfp.vue?vue&type=script&lang=js"
export * from "./jdfp.vue?vue&type=script&lang=js"
import style0 from "./jdfp.vue?vue&type=style&index=0&id=4366e488&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4366e488",
  null
  
)

export default component.exports